import { BackOfficeDtoConverter } from 'shared/services/backoffice-data-provider';

import { Referral } from './models/Referral.model';

export class ReferralDtoConverter extends BackOfficeDtoConverter {
  convert(dto: any) {
    return Referral.fromDto(dto) as any;
  }
}
